// 예시: pages/_app.js

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { RecoilRoot } from 'recoil'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
// import '../styles/globals.css'; // 전역 스타일 파일

function MyApp({ Component, pageProps }) {
  const router = useRouter()
  const isLoginPage = router.pathname === '/login'

  useEffect(() => {
    // const isLoggedIn = document.cookie.includes("auth=true");
    //
    // if (!isLoggedIn && !isLoginPage) {
    //   router.push("/login");
    // }

    if(isLoginPage) {
      document.body.classList.add('membership')
    } else {
      document.body.classList.remove('membership')
    }

    return () => {
      document.body.classList.remove('membership')
    }

  }, [router.pathname])

  return (
    <RecoilRoot>
      <Component {...pageProps} />
      <ToastContainer />
    </RecoilRoot>
  )
}

if (module.hot) {
  module.hot.accept()
}

export default MyApp
